(() => {
  const root = document.documentElement;
  const media = window.matchMedia('(prefers-reduced-motion: reduce)');
  let preference = null;
  try { preference = localStorage.getItem('griffey-motion'); } catch (error) {}
  const applyMotion = () => {
    const paused = preference === 'paused' || media.matches;
    root.classList.toggle('gf-motion-paused', paused);
    document.querySelectorAll('[data-griffey-motion]').forEach(button => {
      button.hidden = media.matches;
      button.setAttribute('aria-pressed', String(paused));
      button.textContent = paused ? button.dataset.resumeLabel : button.dataset.pauseLabel;
    });
  };
  document.addEventListener('click', event => {
    const button = event.target instanceof Element ? event.target.closest('[data-griffey-motion]') : null;
    if (!button) return;
    preference = root.classList.contains('gf-motion-paused') ? 'enabled' : 'paused';
    try { localStorage.setItem('griffey-motion', preference); } catch (error) {}
    applyMotion();
  });
  media.addEventListener('change', applyMotion);
  document.addEventListener('shopify:section:load', applyMotion);
  const initContact = () => {
    const select = document.querySelector('[data-griffey-inquiry]');
    if (!(select instanceof HTMLSelectElement)) return;
    const params = new URL(window.location.href).searchParams;
    const requested = params.get('inquiry');
    if (requested && Array.from(select.options).some(option => option.value === requested)) select.value = requested;
    const details = select.form?.querySelector('[data-griffey-booking]');
    const syncBooking = () => { if (details instanceof HTMLDetailsElement) details.open = select.value === 'booking'; };
    select.addEventListener('change', syncBooking);
    syncBooking();
    const body = select.form?.querySelector('textarea[name="contact[body]"]');
    const product = params.get('product');
    if (product && body instanceof HTMLTextAreaElement && !body.value.trim()) body.value = 'Product: ' + product.slice(0, 200) + '\n\n';
  };
  applyMotion();
  initContact();
})();
